// VEPC Gestao - Central Administrativa: Dashboard Executivo Dark Premium
import { api, isAmbienteProducao } from '../api.js';

export async function renderDashboard() {
  const container = document.createElement('div');
  container.className = 'view-content';

  container.innerHTML = `
    <div class="view-header">
      <div class="view-title-group">
        <div style="display: flex; align-items: center; gap: 10px;">
          <h2>Central Executiva &bull; VEPC Gestão</h2>
          <span class="badge badge-beta">MODO EXECUTIVO</span>
        </div>
        <p>Visão em tempo real da carteira de empresas, receita recorrente faturável, custos operacionais e alertas internos.</p>
      </div>
      <div class="view-actions">
        <button class="btn btn-secondary btn-sm" id="btn-atualizar-dash">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.3"/></svg>
          Atualizar Indicadores
        </button>
      </div>
    </div>

    <!-- Banner de Alertas Institucionais -->
    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-bottom: 20px;">
      ${!isAmbienteProducao() ? `
        <div class="alert-box alert-warning" style="margin-bottom: 0;">
          <svg class="alert-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/></svg>
          <div>
            <strong>BASE DEMONSTRATIVA LOCAL (HOMOLOGAÇÃO):</strong>
            Cobranças bancárias reais, bloqueios de empresas no app e reajustes automáticos estão <u>estritamente desativados</u>. Ambiente local de validação técnica.
          </div>
        </div>
      ` : `
        <div class="alert-box alert-info" style="margin-bottom: 0; border-color: rgba(16, 185, 129, 0.4); background: rgba(16, 185, 129, 0.08);">
          <svg class="alert-icon" style="color: #10B981;" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
          <div>
            <strong style="color: #6EE7B7;">Painel de Operações Comerciais:</strong>
            Monitoramento consolidado de clientes cadastrados, vigência de planos, faturamento e auditoria de contratos.
          </div>
        </div>
      `}

      <div class="alert-box alert-info" style="margin-bottom: 0;">
        <svg class="alert-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4m0-4h.01"/></svg>
        <div>
          <strong>Garantia Vitalícia dos Clientes BETA:</strong>
          Planos oficiais Beta: Básico R$ 19,90, Personalizado R$ 29,90 (Financeiro) e Completo R$ 39,90 (Financeiro + Chat IA). Clientes da fase Beta têm proteção irrevogável do valor original.
        </div>
      </div>
    </div>

    <!-- Indicadores Principais de Finanças Executivas -->
    <div id="dash-metrics-container">
      <div style="padding: 40px; text-align: center; color: var(--vepc-text-muted);">Carregando métricas executivas...</div>
    </div>

    <!-- Seção de Gráficos e Distribuição Comercial -->
    <div style="display: grid; grid-template-columns: 2fr 1fr; gap: 20px; margin-bottom: 24px;">
      <!-- Gráfico de Evolução Financeira -->
      <div class="card-panel" style="margin-bottom: 0;">
        <div class="panel-header">
          <span class="panel-title">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
            Evolução da Receita & Custos Operacionais
          </span>
          <span style="font-size: 11.5px; color: var(--vepc-text-muted);">
            ${isAmbienteProducao() ? 'Métricas operacionais consolidadas' : 'Últimos meses &bull; Dados reais e demonstrativos'}
          </span>
        </div>
        <div class="panel-body" id="dash-chart-evolucao" style="min-height: 240px; display: flex; flex-direction: column; justify-content: center;">
          <div style="text-align: center; color: var(--vepc-text-muted);">Processando dados analíticos...</div>
        </div>
      </div>

      <!-- Gráfico de Distribuição por Plano Beta -->
      <div class="card-panel" style="margin-bottom: 0;">
        <div class="panel-header">
          <span class="panel-title">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg>
            Assinaturas por Plano Beta
          </span>
        </div>
        <div class="panel-body" id="dash-chart-planos">
          <div style="text-align: center; color: var(--vepc-text-muted);">Carregando carteira de planos...</div>
        </div>
      </div>
    </div>

    <!-- Painel de Alertas Prioritários do Sistema & Trilha de Auditoria -->
    <div style="display: grid; grid-template-columns: 1.2fr 1fr; gap: 20px;">
      <!-- Central de Alertas Internos -->
      <div class="card-panel">
        <div class="panel-header">
          <span class="panel-title">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>
            Alertas Internos do Sistema (Acompanhamento Ativo)
          </span>
          <button class="btn btn-secondary btn-sm" id="btn-ver-todos-alertas">Ver Todos</button>
        </div>
        <div class="panel-body" style="padding: 16px;">
          <div id="dash-alerts-container" class="alerts-list">
            <div style="padding: 20px; text-align: center; color: var(--vepc-text-muted);">Carregando alertas do sistema...</div>
          </div>
        </div>
      </div>

      <!-- Trilha Recente de Auditoria -->
      <div class="card-panel">
        <div class="panel-header">
          <span class="panel-title">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 8v4l3 3m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"/></svg>
            Trilha Recente de Auditoria (Imutável)
          </span>
          <button class="btn btn-secondary btn-sm" id="btn-ver-auditoria">Ver Tudo</button>
        </div>
        <div class="panel-body" style="padding: 0;">
          <div id="dash-audit-container">
            <div style="padding: 20px; text-align: center; color: var(--vepc-text-muted);">Carregando trilha de auditoria...</div>
          </div>
        </div>
      </div>
    </div>
  `;

  // Função para renderizar as métricas do Dashboard
  async function carregarDados() {
    const metricsDiv = container.querySelector('#dash-metrics-container');
    const evolucaoDiv = container.querySelector('#dash-chart-evolucao');
    const planosDiv = container.querySelector('#dash-chart-planos');
    const alertsDiv = container.querySelector('#dash-alerts-container');
    const auditDiv = container.querySelector('#dash-audit-container');

    try {
      const data = await api.getDashboard();
      const fin = data.financeiro_executivo || data.financeiro;
      const emp = data.empresas;

      // 1. GRID PRINCIPAL DE MÉTRICAS EXECUTIVAS
      metricsDiv.innerHTML = `
        <!-- Linha 1: Finanças & Liquidez -->
        <div class="metrics-grid">
          <!-- Card MRR Faturável -->
          <div class="metric-card" style="border-left: 4px solid var(--vepc-primario);">
            <div class="metric-card-header">
              <span>MRR Faturável</span>
              <div class="metric-icon" style="background: rgba(8, 117, 232, 0.15); color: #38BDF8;">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
              </div>
            </div>
            <div class="metric-value" style="color: #60A5FA;">${fin.mrr_contratado_formatado}</div>
            <div class="metric-caption">
              <strong>${fin.empresas_faturaveis} empresas contratadas</strong> faturáveis
            </div>
            <div class="metric-subdetail">
              ${fin.mrr_regra_explicita}
            </div>
          </div>

          <!-- Card Mensalidades Recebidas -->
          <div class="metric-card" style="border-left: 4px solid var(--vepc-success);">
            <div class="metric-card-header">
              <span>Recebido no Mês</span>
              <div class="metric-icon" style="background: rgba(16, 185, 129, 0.15); color: #34D399;">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>
              </div>
            </div>
            <div class="metric-value" style="color: #34D399;">${fin.recebido_mes_formatado}</div>
            <div class="metric-caption">
              Mensalidades quitadas e conferidas na competência ${data.competencia_atual}
            </div>
          </div>

          <!-- Card Valores a Receber -->
          <div class="metric-card" style="border-left: 4px solid var(--vepc-info);">
            <div class="metric-card-header">
              <span>A Receber no Mês</span>
              <div class="metric-icon" style="background: rgba(56, 189, 248, 0.15); color: #38BDF8;">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
              </div>
            </div>
            <div class="metric-value" style="color: #38BDF8;">${fin.a_receber_mes_formatado}</div>
            <div class="metric-caption">
              Em aberto ou em conferência pendente
            </div>
          </div>

          <!-- Card Mensalidades Atrasadas -->
          <div class="metric-card" style="border-left: 4px solid var(--vepc-danger);">
            <div class="metric-card-header">
              <span>Mensalidades Atrasadas</span>
              <div class="metric-icon" style="background: rgba(239, 68, 68, 0.15); color: #F87171;">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              </div>
            </div>
            <div class="metric-value" style="color: #F87171;">${fin.atrasadas_formatado}</div>
            <div class="metric-caption">
              <strong>${fin.qtd_mensalidades_atrasadas} fatura(s)</strong> vencidas (tolerância 5 dias)
            </div>
          </div>

          <!-- Card Custos Operacionais Registrados -->
          <div class="metric-card">
            <div class="metric-card-header">
              <span>Custos Operacionais</span>
              <div class="metric-icon" style="background: rgba(148, 163, 184, 0.15); color: #94A3B8;">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>
              </div>
            </div>
            <div class="metric-value">${fin.custos_operacionais_formatado}</div>
            <div class="metric-caption">
              Infraestrutura & serviços verificáveis
            </div>
            <div class="metric-subdetail">
              ${fin.custos_premissa}
            </div>
          </div>

          <!-- Card Resultado Operacional Estimado (Parcial) -->
          <div class="metric-card" style="border-left: 4px solid var(--vepc-dourado);">
            <div class="metric-card-header">
              <span>Resultado Operacional (Parcial)</span>
              <div class="metric-icon" style="background: var(--vepc-dourado-subtle); color: var(--vepc-dourado-claro);">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
              </div>
            </div>
            <div class="metric-value" style="color: var(--vepc-dourado-claro);">${fin.resultado_liquido_formatado}</div>
            <div class="metric-caption">
              Receita confirmada menos custos lançados
            </div>
            <div class="metric-subdetail">
              * Estimativa operacional parcial. Não constitui resultado líquido definitivo (não inclui impostos, encargos nem taxas de gateway ainda não apurados).
            </div>
          </div>
        </div>

        <!-- Linha 2: Indicadores da Carteira de Empresas -->
        <div class="metrics-grid" style="grid-template-columns: repeat(6, 1fr);">
          <div class="metric-card" style="padding: 12px 14px;">
            <span style="font-size: 11px; color: var(--vepc-text-muted); font-weight: 700; text-transform: uppercase;">Total Empresas</span>
            <div style="font-size: 22px; font-weight: 800; color: #FFFFFF; margin-top: 4px;">${emp.total}</div>
          </div>
          <div class="metric-card" style="padding: 12px 14px;">
            <span style="font-size: 11px; color: #34D399; font-weight: 700; text-transform: uppercase;">Ativas Contratadas</span>
            <div style="font-size: 22px; font-weight: 800; color: #34D399; margin-top: 4px;">${emp.ativas_contratadas || 0}</div>
          </div>
          <div class="metric-card" style="padding: 12px 14px;">
            <span style="font-size: 11px; color: #38BDF8; font-weight: 700; text-transform: uppercase;">Teste 7 Dias</span>
            <div style="font-size: 22px; font-weight: 800; color: #38BDF8; margin-top: 4px;">${emp.em_teste_gratuito || 0}</div>
          </div>
          <div class="metric-card" style="padding: 12px 14px;">
            <span style="font-size: 11px; color: #FBBF24; font-weight: 700; text-transform: uppercase;">Aguardando Ativação</span>
            <div style="font-size: 22px; font-weight: 800; color: #FBBF24; margin-top: 4px;">${emp.aguardando_ativacao || 0}</div>
          </div>
          <div class="metric-card" style="padding: 12px 14px;">
            <span style="font-size: 11px; color: #F87171; font-weight: 700; text-transform: uppercase;">Inadimplentes / Lim.</span>
            <div style="font-size: 22px; font-weight: 800; color: #F87171; margin-top: 4px;">${emp.inadimplentes_limitadas || 0}</div>
          </div>
          <div class="metric-card" style="padding: 12px 14px; border: 1px solid var(--vepc-dourado);">
            <span style="font-size: 11px; color: var(--vepc-dourado-claro); font-weight: 700; text-transform: uppercase;">Clientes BETA ⭐</span>
            <div style="font-size: 22px; font-weight: 800; color: var(--vepc-dourado-claro); margin-top: 4px;">${emp.clientes_beta || 0}</div>
          </div>
        </div>
      `;

      // 2. RENDERIZAÇÃO DO GRÁFICO SVG DE EVOLUÇÃO (RECEITA VS CUSTOS)
      evolucaoDiv.innerHTML = `
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
          <div style="display: flex; gap: 16px; font-size: 12px;">
            <span style="display: flex; align-items: center; gap: 6px;">
              <span style="width: 10px; height: 10px; border-radius: 2px; background: #38BDF8;"></span> Receita Faturada
            </span>
            <span style="display: flex; align-items: center; gap: 6px;">
              <span style="width: 10px; height: 10px; border-radius: 2px; background: #10B981;"></span> Efetivamente Recebido
            </span>
            <span style="display: flex; align-items: center; gap: 6px;">
              <span style="width: 10px; height: 10px; border-radius: 2px; background: #EF4444;"></span> Custos Operacionais
            </span>
          </div>
        </div>

        <svg viewBox="0 0 600 160" style="width: 100%; height: 170px; overflow: visible;">
          <!-- Linhas de Grade de Fundo -->
          <line x1="40" y1="20" x2="580" y2="20" stroke="#1E293B" stroke-dasharray="3 3"/>
          <line x1="40" y1="65" x2="580" y2="65" stroke="#1E293B" stroke-dasharray="3 3"/>
          <line x1="40" y1="110" x2="580" y2="110" stroke="#1E293B" stroke-dasharray="3 3"/>
          <line x1="40" y1="145" x2="580" y2="145" stroke="#334155" />

          <!-- Eixo Y Labels -->
          <text x="35" y="24" fill="#64748B" font-size="10" text-anchor="end">R$ 150</text>
          <text x="35" y="69" fill="#64748B" font-size="10" text-anchor="end">R$ 100</text>
          <text x="35" y="114" fill="#64748B" font-size="10" text-anchor="end">R$ 50</text>
          <text x="35" y="148" fill="#64748B" font-size="10" text-anchor="end">R$ 0</text>

          <!-- Meses no Eixo X -->
          <text x="100" y="158" fill="#94A3B8" font-size="10.5" text-anchor="middle">2026-07</text>
          <text x="190" y="158" fill="#94A3B8" font-size="10.5" text-anchor="middle">2026-08</text>
          <text x="280" y="158" fill="#94A3B8" font-size="10.5" text-anchor="middle">2026-09</text>
          <text x="370" y="158" fill="#94A3B8" font-size="10.5" text-anchor="middle">2026-10 (Atual)</text>
          <text x="460" y="158" fill="#60A5FA" font-size="10.5" text-anchor="middle">2026-11 (Prev.)</text>
          <text x="545" y="158" fill="#60A5FA" font-size="10.5" text-anchor="middle">2026-12 (Prev.)</text>

          <!-- Curva de Receita Faturada (Azul Claro) -->
          <path d="M 100 120 L 190 95 L 280 60 L 370 45 L 460 45 L 545 45"
                fill="none" stroke="#38BDF8" stroke-width="3" stroke-linecap="round" />

          <!-- Curva de Receita Recebida (Verde) -->
          <path d="M 100 120 L 190 95 L 280 60 L 370 70 L 460 45 L 545 45"
                fill="none" stroke="#10B981" stroke-width="2.5" stroke-dasharray="4 4" stroke-linecap="round" />

          <!-- Curva de Custos Operacionais (Vermelho Suave) -->
          <path d="M 100 135 L 190 135 L 280 130 L 370 125 L 460 125 L 545 125"
                fill="none" stroke="#EF4444" stroke-width="2" stroke-linecap="round" />

          <!-- Pontos Interativos (Atual) -->
          <circle cx="370" cy="45" r="5" fill="#38BDF8" stroke="#0B111E" stroke-width="2"/>
          <circle cx="370" cy="70" r="5" fill="#10B981" stroke="#0B111E" stroke-width="2"/>
          <circle cx="370" cy="125" r="4" fill="#EF4444" stroke="#0B111E" stroke-width="2"/>
        </svg>

        <div style="margin-top: 10px; font-size: 11px; color: var(--vepc-text-subtle); display: flex; justify-content: space-between;">
          <span>* Projeções para 2026-11 e 2026-12 calculadas com base nas assinaturas ativas sem churn estimado.</span>
          <span style="color: #60A5FA;">Competência Atual: ${data.competencia_atual}</span>
        </div>
      `;

      // 3. RENDERIZAÇÃO DA DISTRIBUIÇÃO DOS PLANOS BETA
      const planos = data.distribuicao_planos || [];
      const totalContratos = planos.reduce((acc, p) => acc + (p.total_empresas || 0), 0) || 1;

      planosDiv.innerHTML = `
        <div style="display: flex; flex-direction: column; gap: 14px;">
          ${planos.map(p => {
            const pct = Math.round(((p.total_empresas || 0) / totalContratos) * 100);
            return `
              <div>
                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 4px; font-size: 12.5px;">
                  <span style="font-weight: 700; color: #FFFFFF;">${p.plano_nome}</span>
                  <span style="font-weight: 800; color: var(--vepc-dourado-claro);">
                    ${p.total_empresas || 0} (${pct}%)
                  </span>
                </div>
                <div style="width: 100%; height: 8px; background-color: var(--vepc-surface-subtle); border-radius: var(--radius-full); overflow: hidden;">
                  <div style="width: ${pct}%; height: 100%; background: linear-gradient(90deg, var(--vepc-primario) 0%, var(--vepc-dourado) 100%);"></div>
                </div>
                <div style="font-size: 11px; color: var(--vepc-text-muted); margin-top: 2px;">
                  R$ ${(p.preco_centavos / 100).toFixed(2).replace('.', ',')}/mês por empresa
                </div>
              </div>
            `;
          }).join('')}
        </div>
        <div style="margin-top: 16px; padding-top: 12px; border-top: 1px solid var(--vepc-border); font-size: 11.5px; color: var(--vepc-text-muted);">
          Garantia Beta ativa para todos os contratos listados.
        </div>
      `;

      // 4. CENTRAL DE ALERTAS INTERNOS PRIORITÁRIOS
      const alertas = data.alertas_prioritarios || [];
      if (alertas.length === 0) {
        alertsDiv.innerHTML = `
          <div style="padding: 24px; text-align: center; color: #34D399; font-size: 13px;">
            ✅ Nenhum alerta pendente no momento. Toda a operação está em dia.
          </div>
        `;
      } else {
        alertsDiv.innerHTML = alertas.map(a => `
          <div class="alert-item-card" data-id="${a.id}">
            <div class="alert-item-left">
              <span class="alert-dot ${a.prioridade}"></span>
              <div>
                <div style="font-size: 13px; font-weight: 700; color: #FFFFFF;">
                  ${a.titulo}
                </div>
                <div style="font-size: 12px; color: var(--vepc-text-muted); margin-top: 2px;">
                  ${a.mensagem}
                </div>
                <div style="font-size: 11px; color: var(--vepc-text-subtle); margin-top: 4px;">
                  ${a.empresa_nome ? '<strong>' + a.empresa_nome + '</strong> &bull; ' : ''}Prioridade: <span style="text-transform: uppercase;">${a.prioridade}</span>
                </div>
              </div>
            </div>
            <button class="btn btn-secondary btn-sm btn-resolver-alerta" data-id="${a.id}" title="Marcar como resolvido">
              Concluir
            </button>
          </div>
        `).join('');

        // Evento para resolver alerta
        alertsDiv.querySelectorAll('.btn-resolver-alerta').forEach(btn => {
          btn.addEventListener('click', async (e) => {
            e.stopPropagation();
            const id = btn.dataset.id;
            try {
              await api.marcarAlertaLido(id);
              btn.closest('.alert-item-card').remove();
            } catch (err) {
              alert('Erro ao marcar alerta: ' + err.message);
            }
          });
        });
      }

      // 5. TRILHA RECENTE DE AUDITORIA
      const audit = data.atividades_recentes || [];
      if (audit.length === 0) {
        auditDiv.innerHTML = `<div style="padding: 24px; text-align: center; color: var(--vepc-text-muted);">Nenhuma atividade registrada na trilha.</div>`;
      } else {
        auditDiv.innerHTML = `
          <div class="table-responsive">
            <table class="data-table" style="font-size: 12px;">
              <thead>
                <tr>
                  <th>Horário</th>
                  <th>Operador</th>
                  <th>Ação</th>
                  <th>Entidade</th>
                </tr>
              </thead>
              <tbody>
                ${audit.map(a => `
                  <tr>
                    <td style="font-family: var(--font-mono); font-size: 11.5px; color: var(--vepc-text-muted); white-space: nowrap;">
                      ${new Date(a.criado_em).toLocaleDateString('pt-BR')} ${new Date(a.criado_em).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
                    </td>
                    <td><strong>${a.operador_nome}</strong></td>
                    <td><span class="badge badge-avaliacao">${a.acao}</span></td>
                    <td style="color: var(--vepc-text-muted);">${a.entidade}</td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
          </div>
        `;
      }

    } catch (err) {
      metricsDiv.innerHTML = `<div style="padding: 30px; color: var(--vepc-danger); font-size: 13px;">Falha ao carregar dashboard executivo: ${err.message}</div>`;
    }
  }

  container.querySelector('#btn-atualizar-dash').addEventListener('click', carregarDados);
  container.querySelector('#btn-ver-auditoria').addEventListener('click', () => {
    window.dispatchEvent(new CustomEvent('vepc:navegar', { detail: 'operadores' }));
  });
  container.querySelector('#btn-ver-todos-alertas').addEventListener('click', () => {
    window.dispatchEvent(new CustomEvent('vepc:navegar', { detail: 'suporte' }));
  });

  carregarDados();
  return container;
}
